import React, { useEffect, useState } from "react";
import { Alert, Modal, Select } from "antd";
import styles from "./index.module.scss";
import Webcam from "react-webcam";

export default function WebCamDetect() {
    const [loaded, setLoaded] = useState(false); // 摄像头已开始工作
    const [deviceId, setDeviceId] = React.useState<string>("");
    const [devices, setDevices] = React.useState<MediaDeviceInfo[]>([]);
    const [error, setError] = useState<any>();

    useEffect(() => {
        if (!loaded) return;
        try {
            navigator.mediaDevices.enumerateDevices().then(mediaDevices => {
                const deviceList = mediaDevices.filter(
                    ({ kind }) => kind === "videoinput"
                );
                setDevices(deviceList);
                setDeviceId(deviceList[0]?.deviceId);
            });
        } catch (e) {
            Modal.error({ content: "您的设备无可用摄像头" });
        }
    }, [loaded]);

    function onUserMedia(stream: MediaStream) {
        setError(undefined);
        setLoaded(true);
    }

    function onUserMediaError(error: any) {
        setError(error);
        setLoaded(true);
    }

    return (
        <div
            className={styles.root}
            style={{ visibility: loaded ? "visible" : "hidden" }}>
            {error && (
                <Alert
                    message="检测到摄像头无法正常工作"
                    description={
                        <div>
                            请修改浏览器设置，允许白果云使用摄像头，修改后刷新浏览器，如果依然提示摄像头无法正常工作，请确认您的电脑有可用的摄像头
                            <br />
                            可能原因：摄像头被占用/摄像头驱动异常
                            <br />
                            建议：重新电脑/更换摄像头/更换电脑
                            <br />
                        </div>
                    }
                    type="error"
                    showIcon
                />
            )}

            {loaded && !error && (
                <Alert message="已检测到摄像头" type="success" showIcon />
            )}

            <div className={styles.webcam}>
                <div className={styles.left}>
                    {!error && (
                        <Webcam
                            width={200}
                            videoConstraints={{ deviceId }}
                            onUserMedia={onUserMedia}
                            onUserMediaError={onUserMediaError}
                            minScreenshotHeight={400}
                            minScreenshotWidth={600}
                            screenshotQuality={0.6}
                            screenshotFormat="image/jpeg"
                        />
                    )}

                    {error && (
                        <div className={styles.error}>
                            检测到摄像头无法正常工作，请重启电脑、更换摄像头或更换电脑。
                        </div>
                    )}
                </div>

                <div className={styles.right}>
                    {devices.length > 1 && (
                        <div>
                            摄像头
                            <Select
                                placeholder="请选择摄像头"
                                value={deviceId}
                                onSelect={setDeviceId}
                                style={{ marginBottom: 10, marginLeft: 10 }}>
                                {devices.map(item => (
                                    <Select.Option
                                        key={item.deviceId}
                                        value={item.deviceId}>
                                        {item.label}
                                    </Select.Option>
                                ))}
                            </Select>
                        </div>
                    )}

                    <div className={styles.tip}>
                        <p>摄像头不可用怎么办</p>
                        <p>a.可用电脑登录微信并发起视频，确认摄像头是否可用</p>
                        <p>
                            b.修改浏览器摄像头使用权限，如果有多个摄像头可以切换选择其他摄像头
                        </p>
                        <p>
                            c.请关闭电脑的360、杀毒软件、代理VPN等软件，关闭后鼠标右键点击“重新加载”刷新浏览器
                        </p>
                        <p>d.建议使用Chrome谷歌浏览器</p>
                        <p>
                            e.如果依然显示摄像头不可用，请重启电脑、更换摄像头或更换电脑
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
